module.exports = __webpack_public_path__ + "img/welcomeHome.5f37777d.jpeg";